export default "__VITE_PUBLIC_ASSET__49be1166__"